// extracted by mini-css-extract-plugin
module.exports = {"bim":"BIMPaper_bim_2Bsx2","selectedBim":"BIMPaper_selectedBim_2e7Ld"};